import { Typography } from '@freighthub/silhouette-core'
import { FC } from 'react'
import { useI18n } from 'utils/localisation'

import { useDocumentTypeState } from './service/useDocumentTypes'

type DocumentTypeNameProps = {
  documentType: string
}

export const DocumentTypeName: FC<DocumentTypeNameProps> = ({ documentType }) => {
  const { documentTypes } = useDocumentTypeState()
  const { translate } = useI18n()
  const currentDocumentType = documentTypes.find((docType) => docType.code === documentType)

  // @ts-expect-error TS(2345) FIXME: Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
  const translatedDocumentTypeDisplayName = translate(currentDocumentType?.code)

  const documentDisplayName =
    translatedDocumentTypeDisplayName === currentDocumentType?.code
      ? currentDocumentType?.displayName
      : translatedDocumentTypeDisplayName

  return <Typography component="span">{documentDisplayName}</Typography>
}
